import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PublicLandingPage from "./components/PublicLandingPage";

import PropertyDetails from "./components/PropertyDetails";
import AdminLandingPage from "./components/AdminLandingPage";
import Login from "./components/Login";
import PropertiesMaintenance from "./components/PropertiesMaintenance";
import UsersMaintenance from "./components/UsersMaintenance";
import ChangePassword from "./components/ChangePassword";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public site */}
        <Route path="/" element={<PublicLandingPage />} />
        <Route path="/property/:id" element={<PropertyDetails />} />

        {/* Admin site */}
        <Route path="/admin" element={<AdminLandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin/properties" element={<PropertiesMaintenance />} />
        <Route path="/admin/users" element={<UsersMaintenance />} />
        <Route path="/change-password" element={<ChangePassword />} />
      </Routes>
    </Router>
  );
}

export default App;
